<template>
  <v-tooltip left class="maximized-child-content">
    <template v-slot:activator="{ on }">
      <v-btn fab bottom right dark fixed
             color="primary" class="hiddeBotton" v-on="on" @click="showIncidencia"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <span>Incidencia Rápida</span>
  </v-tooltip>
</template>

<script>
import incidenciaNew from '@/pages/incidencias/edit.vue'
import { EventBus } from '@/store/EventBus.js'

export default {
  methods: {
    showIncidencia () {
      EventBus.$emit('showModal', { component: incidenciaNew, props: { fullForm: false } })
    }
  }
}
</script>

<style>
@media print {
  .hiddeBotton {
    display: none;
  }
}
</style>
